import { fmtMsg } from "commonui";
import { LessonPlanLocale } from "@/locales/localeid";
import { EmptyGuid } from "@/util/constants";
import { VCSLevelModel } from "./../../models/title-list-model";

export interface TransitionModel {
	id: string;
	text: string;
	title: string;
	duration: number;
	isCommon: boolean;
	vcsLevelId?: number;
	versionGroupId: string;
	lessonPlans: LessonPlanModel[];
}

export enum TransitionModelPropName {
	Id = "id",
	Text = "text",
	Title = "title",
	Duration = "duration",
	IsCommon = "isCommon",
	VersionGroupId = "versionGroupId"
}

export const EmptyTransition: TransitionModel = {
	id: EmptyGuid,
	text: fmtMsg(LessonPlanLocale.LessonPlanMasterPlanManageTransitionCustomTitle),
	title: "",
	duration: 0,
	isCommon: false,
	versionGroupId: EmptyGuid,
	lessonPlans: []
};

export interface LessonPlanModel {
	id: string;
	unitId: number;
	sequence: number;
	vcsLevel: VCSLevelModel;
	lessonPlanVersionId: string;
}
